import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { SnackbarService } from '../../services/snackbar.service';
import { SnackbarConfig } from '../../models/zen-snackbar.model';
import { ZenIconComponent } from '../zen-icon/zen-icon.component';

@Component({
  selector: 'zen-snackbar',
  standalone: true,
  imports: [CommonModule, ZenIconComponent],
  templateUrl: './zen-snackbar.component.html',
  styleUrl: './zen-snackbar.component.scss',
})
export class SnackbarComponent implements OnInit {
  /**
   * Variable which is used to acess the SnackbarConfig data
   */
  @Input() snackBarData: SnackbarConfig | undefined;
  /**
  * Variable used to emit button actions.
  * @type {boolean}
  */
  @Output() closeSnack = new EventEmitter();
  /**
   * Component constructor which is used to inject the required services.
   * @param service To acess the Snackbar service for show and hide tha snackbar
   */
  constructor(private service: SnackbarService, @Inject(DOCUMENT) private document: Document) { }
  /**
  * Component life cycle hook.
  */
  ngOnInit() {
    if (this.snackBarData) {
      this.setStyle('--zsb-h-position', this.snackBarData && this.snackBarData.horizontalPosition ? this.snackBarData && this.snackBarData.horizontalPosition : 'center');
    }
    this.service.snackbarClose.subscribe((res)=>{
      if(res){
        this.closeSnack.emit({Close:res});
      }
    })
  }
  /**
   * Method is used to close the snackbar
   */
  closeSnackbar() { 
    this.service.hideSnackBar()
  }
  /**
   * Method is used to set Style for css Property
   * @param propertyName To contain the css property name
   * @param value To contain the css value
   */
  setStyle(propertyName: string, value: string) {
    this.document.documentElement.style.setProperty(propertyName, value)
  }
}
